import React from 'react';

export const Save = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 23H22C23.1046 23 24 22.1046 24 21V7.80843C24 7.27799 23.7893 6.76929 23.4142 6.39421L18.6058 1.58579C18.2307 1.21071 17.722 1 17.1916 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M6 12C6 11.4477 6.44772 11 7 11H18C18.5523 11 19 11.4477 19 12V23H6V12Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <mask id="path-3-inside-1" fill="white">
      <path d="M5 5C5 4.44772 5.44772 4 6 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H6C5.44772 6 5 5.55228 5 5Z" />
    </mask>
    <path
      d="M6 6H16V2H6V6ZM16 4H6V8H16V4ZM6 4C6.55229 4 7 4.44772 7 5H3C3 6.65685 4.34314 8 6 8V4ZM15 5C15 4.44772 15.4477 4 16 4V8C17.6569 8 19 6.65685 19 5H15ZM16 6C15.4477 6 15 5.55228 15 5H19C19 3.34315 17.6569 2 16 2V6ZM6 2C4.34315 2 3 3.34315 3 5H7C7 5.55228 6.55228 6 6 6V2Z"
      fill="currentColor"
      mask="url(#path-3-inside-1)"
    />
  </svg>
);
